import { h, Component, Fragment } from "preact";

export default ({children}) => <div id="wrapper">
    <section id="main-section" class="main-content-section min-h-screen">
        {children}
    </section>
</div>;